import axios from "axios";
import { baseUrlCloudFunc } from "../../config/api/apiConfig";

class WorkshopService {
  private axios = axios.create({
    baseURL: baseUrlCloudFunc,
  });

  private axiosFile = axios.create({
    baseURL: baseUrlCloudFunc,
    responseType: "blob",
  });

  public setToken(token: string) {
    this.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    this.axiosFile.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  public async uploadBillKPB(inputData?: any) {
    try {
      return await this.axios.put<any>("/Workshop__ServiceKPB/service/upload-bill-kpb", inputData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (e: any) {
      throw e.response.data.error.message;
    }
  }
}

export const workshopService = new WorkshopService();
